import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { TOMORROW, intervalMapping } from "../constants";
dayjs.extend(utc);
dayjs.extend(timezone);

const HK_TZ = "Asia/Hong_Kong";

// get formatted amount unit text
export const getAmountUnitText = (
  interval: string,
  interval_count: number
  //   price: number
) => {
  if (interval_count > 1) {
    return `/${intervalMapping[interval as keyof typeof intervalMapping]}`;
  } else {
    return `/${intervalMapping[interval as keyof typeof intervalMapping]}`;
  }
};

export const nowHK = (): dayjs.Dayjs => dayjs().tz(HK_TZ);

/** CMS-core ISO `Z` / offset → Hong Kong clock. Same as CMS `asHktInstant`. */
export const toHK = (d?: string | Date | dayjs.Dayjs | null) =>
  dayjs.utc(d ?? undefined).tz(HK_TZ);

/** Lot platform ISO `+08:00` → Hong Kong wall clock. Offset-aware; never `.utc()`. */
export const toLotHK = (d?: string | Date | dayjs.Dayjs | null) =>
  dayjs(d ?? undefined).tz(HK_TZ);

// get monthly order item start date range config
export const getBookingSelectDateRange = (startDate: string): string => {
  const now = new Date();
  const _startDate = new Date(startDate);
  const isDefaultStartDateIsBeforeToday = _startDate >= now;

  const finalStartDate = isDefaultStartDateIsBeforeToday
    ? dayjs(startDate, "YYYY-MM-DD").format("YYYY-MM-DD")
    : TOMORROW;

  return finalStartDate;
};

// get formatted octopus number and last digit
export const getExtractParts = (
  text: string
): { numberPart: string; insideParentheses: string } => {
  const numberPartMatch = text.match(/^(\d+)\(/);
  const insideParenthesesMatch = text.match(/\((\d+)\)$/);

  const numberPart = numberPartMatch ? numberPartMatch[1] : "";
  const insideParentheses = insideParenthesesMatch
    ? insideParenthesesMatch[1]
    : "";

  return { numberPart, insideParentheses };
};

// get parking location tag
export const getLocationTag = (district_id: number) => {
  if (district_id >= 1 && district_id <= 4) {
    return { key: "hk", value: "TXT_District_Option_HongKong" };
  }
  if (district_id >= 5 && district_id <= 9) {
    return { key: "kl", value: "TXT_District_Option_Kowloon" };
  }
  if (district_id >= 10 && district_id <= 18) {
    return { key: "nt", value: "TXT_District_Option_NewTerritories" };
  }

  return { key: "-", value: "-" };
};
